import './modules/common';
import 'lightgallery';
import 'lightslider';
import 'lg-zoom';
import 'lg-thumbnail';

$("#images").lightSlider({
    gallery: true,
    item: 1,
    loop: true,
    thumbItem: 4,
    slideMargin: 0,
    enableDrag: true,
    enableTouch: true,
    currentPagerPosition: 'left',
    onSliderLoad: function (el) {
        el.lightGallery({
            selector: '#images .lslide'
        });
    }
});
